/* unplugin-vue-components disabled */import script from "./DiceItem.vue?vue&type=script&setup=true&lang=js"
export * from "./DiceItem.vue?vue&type=script&setup=true&lang=js"

import "./DiceItem.vue?vue&type=style&index=0&id=5cedb0be&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cedb0be"]])

export default __exports__